require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./epfl-middle-east-0-4-5.json") })
        }
      }, "path---epfl-middle-east-0-4-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---epfl-middle-east-0-4-5!./.cache/json/epfl-middle-east-0-4-5.json
// module id = 416
// module chunks = 231608221292675